import StoredLayout from '../../layouts/StoredLayout'
import ReactSelectView from './ReactSelectView'
export default StoredLayout(ReactSelectView)



// WEBPACK FOOTER //
// ./src/forms/react-select/index.js